import App from './App.vue'
import router from './route'
import 'default-passive-events'
import '@/assets/icon/fa/css/all.min.css'
import 'element-plus/dist/index.css'
import * as Icons from '@element-plus/icons-vue'

import { createApp, createVNode } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { selectLoadMore } from './directives/selectLoadMore';
import {infiniteScroll} from "./directives/infiniteScroll"


const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)






const app = createApp(App)


app.use(pinia)
app.use(router)

// 全局注册指令
app.directive('select-loadmore', selectLoadMore);
app.directive("loadmore", infiniteScroll)


Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key as keyof typeof Icons])
})

app.mount('#app')
